module.exports = __webpack_public_path__ + "static/media/contact.5d39153c.mp4";